import script from "./CreateSelfResponse.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateSelfResponse.vue?vue&type=script&setup=true&lang=ts"

import "./CreateSelfResponse.vue?vue&type=style&index=0&id=868f2426&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-868f2426"]])

export default __exports__